// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3uA_c","label":"Labeled_label__3hDyL","divider":"Labeled_divider__QhvY7"};